import React, { Component } from 'react';




export default class DeleteModal extends Component {
    // constructor() {
    //     super()
    // }

    render() {
        if (this.props.mystate.isModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                    <div class="modal-dialog friendly-calls-modal" role="document">
                        <div class="modal-content">
                            <div className='delete-modal'>
                            <h4>Delete Tour</h4>
                            <p>Are you sure you want to delete this tour</p>
                            <div className='delete-modal-btn'>
                            <button type='button' class="btn cnfrm-btn" onClick={()=>this.props.DeleteTour()}>Confirm</button>
                            <button type='button' class="btn cancl-btn"onClick={()=>this.props.CloseDeleteModal()}>Cancel</button>
                            </div>
                            </div>

                           
                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}